<ts-button
  color="secondary"
  text="See Templates"
  icon-mobile="grid_on"
  icon-button-px="1000"
  (clickFn)="onSeeTemplatesClick()"
>
</ts-button>
